export interface ConfigRecord {
	[key: string]: any;
}

export class RecordData {
	private _record: ConfigRecord = {};
	private _name: string = '';

	public getParameter(parameter: string): any {
		return this._record[parameter];
	}

	public set record(value: ConfigRecord) {
		this._record = value;
	}

	public get record(): ConfigRecord {
		return this._record;
	}

	public set name(value: string) {
		this._name = value;
	}

	public get name(): string {
		return this._name;
	}
}

export class GameConfig {

	protected _config: RecordData[] = [];

	public loadConfig(configData: any): void {
		for (const data in configData) {
			const record = new RecordData;
			record.record = configData[data];
			record.name = configData[data].name;
			this._config.push(record);
		}
	}

	public getConfigByName(name: string): RecordData {
		return this._config.find(record => record.name === name);
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/config/GameConfig.ts